<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="90vw">
    <v-card>
      <v-card-title>
        <span class="headline">案件予算詳細</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-layout column mb-4>
            <v-flex class="label">期間</v-flex>
            <v-flex :class="['value', budget.isNew ? 'is-new' : '']">
              <AppPeriod
                :start="ioStartDatePartDate"
                :end="ioEndDatePartDate"
              />
            </v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">予算</v-flex>
            <v-flex :class="['value', budget.isNew ? 'is-new' : '']">
              <AppCurrency
                :value="budget.summary.budget"
                :currency="currency"
              />
            </v-flex>
          </v-layout>
          <v-layout column>
            <v-flex class="label">申請履歴</v-flex>
            <v-flex>
              <HistoryTable :items="budget.requests" :currency="currency" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('input', false)">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import HistoryTable from './HistoryTable'
import dayjs from 'dayjs'

export default {
  name: 'DetailModal',
  components: { HistoryTable },
  props: {
    value: Boolean,
    advertiser: {
      type: Object,
      require: false,
      default: () => {},
    },
    budget: {
      type: Object,
      require: false,
      default: () => {},
    },
  },
  computed: {
    currency() {
      return this.advertiser.currency
    },
    ioStartDatePartDate() {
      return dayjs(this.budget.startTime).format('YYYY-MM-DD')
    },
    ioEndDatePartDate() {
      return dayjs(this.budget.endTime).format('YYYY-MM-DD')
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.value {
  font-size: 16px;

  &.is-new {
    color: #999999;
  }
}
</style>
